/**
 * Who a highlight is about, which is not always who is being viewed.
 *
 * `selectedPersonId` answers "who is the View Name panel showing". While a person is being added
 * they do not exist in SLS yet, so the add panels publish their pending ARK to `createdPersonId`
 * and it takes precedence for as long as the add lasts. `activeFieldInfo.personId` is the last
 * resort, for a field that already knows its own owner.
 *
 * `createdPersonId` can only win while an add flow is open, because the panel hosting the add releases
 * it on close. So a stale created person cannot outrank a live selection.
 *
 * @param {Object} [r2State] - R2 state.
 * @param {Object} [activeFieldInfo] - Active field from the SLS highlights context.
 * @returns {string} The person id, or '' when none resolves.
 */

export const getHighlightSubjectPersonId = (r2State, activeFieldInfo) =>
  r2State?.createdPersonId || r2State?.selectedPersonId || activeFieldInfo?.personId || ''
